import autobind from 'autobind-decorator';
import { computed, observable, action, toJS } from 'mobx';

@autobind
class LoLMatchRankModel {
  constructor(data) {
    this.list = this.formatList(data.seasonRanking);
  }

  formatList(data) {
    let result = [];
    if (data === undefined) {
      return result;
    }
    const { awayStandard, homeStandard, total } = data;
    if (total !== undefined) {
      const totalList = {
        data: [],
        tabName: '전체'
      };
      let tournamentList = {};

      total.map((value, key) => {
        const { tournamentGroup } = value;
        if (tournamentGroup !== '') {
          if (tournamentList[tournamentGroup]) {
            tournamentList[tournamentGroup].data.push(value);
          } else {
            tournamentList[tournamentGroup] = {
              data: [],
              tabName: `${tournamentGroup}조`
            };
            tournamentList[tournamentGroup].data.push(value);
          }
        } else {
          totalList.data.push(value);
        }
      });
      result = result.concat(Object.values(tournamentList));
      totalList.data.length > 0 && result.push(totalList);
    }

    if (homeStandard !== undefined) {
      const homeList = {
        data: [],
        tabName: '홈경기'
      };
      homeStandard.map((value, key) => {
        homeList.data.push(value);
      });
      result.push(homeList);
    }

    if (awayStandard !== undefined) {
      const awayList = {
        data: [],
        tabName: '원정경기'
      };
      awayStandard.map((value, key) => {
        awayList.data.push(value);
      });
      result.push(awayList);
    }

    return result;
  }

  @observable
  selectedTab = 1;

  @observable
  list = [];

  @computed
  get rankList() {
    const { list, selectedTab } = this;

    if (list.length > 1) {
      return list[selectedTab - 1].data;
    } else {
      if (list.length > 0) {
        return list[0].data;
      } else {
        return [];
      }
    }
  }

  @computed
  get tabs() {
    const { list } = this;

    if (list.length > 1) {
      return list.map((item, idx) => {
        return { key: idx + 1, value: item.tabName };
      });
    } else {
      return [];
    }
  }

  /**********************************************************
   * action
   **********************************************************/
  @action
  setSelectedTab(tab) {
    this.selectedTab = tab;
  }
}

export default LoLMatchRankModel;
